/**
 * Single source of truth for the `objectTypeId:objectRecordId` association-ref
 * string convention.
 *
 * A type-only ("Category") association carries `objectRecordId: null` — the
 * wildcard segment is `*`, matching the backend's
 * `ref_parser.WILDCARD_RECORD_SEGMENT` (see
 * `backend/src/matic/relay/api/shared/ref_parser.py`). Building this by hand
 * as `` `${typeId}:${recordId}` `` stringifies `null` to the literal text
 * `"null"` instead of `*` — the backend rejects it (`UUID("null")` raises),
 * and in-memory aggregation keys silently collide/diverge from the wire
 * convention. Always go through this helper instead.
 */
export function buildAssociationRef(
  objectTypeId: string,
  objectRecordId: string | null
): string {
  return `${objectTypeId}:${objectRecordId ?? '*'}`;
}
